<template>
  <div class="investor_particulars">
    <van-tabs
      :title-active-color="'#36B374'"
      :title-inactive-color="'#333333'"
      :line-width="'46px'"
      :line-height="'2px'"
    >
      <van-tab title="基本信息">
        <div class="project_list">
          <div class="list_message">
            <div class="top">
              <span class="name" v-if="category == 5">{{details.operatingName}}</span>
              <span class="name" v-else>{{details.title}}</span>
            </div>
            <div class="body" v-if="category == 1">
              <p class="content">
                <span class="title">项目名称：&nbsp;&nbsp;&nbsp;</span>
                <span class="obj">{{details.projectName}}</span>
              </p>
              <p class="content">
                <span class="title">建设地点：&nbsp;&nbsp;&nbsp;</span>
                <span class="obj">{{details.locationName}}</span>
              </p>
              <p class="content">
                <span class="title">项目类别：&nbsp;&nbsp;&nbsp;</span>
                <span class="obj">{{details.projectTypeName}}</span>
              </p>
              <p class="content">
                <span class="title">计划投资额：</span>
                <span class="obj">{{details.investmentMoney || 0}}亿</span>
              </p>
              <p class="content">
                <span class="title">信息状态：&nbsp;&nbsp;&nbsp;</span>
                <span class="obj" v-if="details.statue == 1">草稿</span>
                <span class="obj" v-if="details.statue == 10">审核中</span>
                <span class="obj" v-if="details.statue == 20">审核通过</span>
                <span class="obj" v-if="details.statue == 30">审核驳回</span>
                <span class="obj" v-if="details.statue == 40">发布</span>
                <span class="obj" v-if="details.statue == 50">下线</span>
              </p>
              <p class="content"  v-if="details.statue == 30">
                <span class="title">驳回原因：&nbsp;&nbsp;&nbsp;</span>
                <span class="obj">{{ details.rejectReason || getRejectReasonL}}</span>
                <!-- <span class="obj">{{rejectResonText}}</span> -->
              </p>
              <p class="content">
                <span class="title">审核人：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                <span class="obj">{{details.auditorName}}</span>
              </p>
              <p class="content">
                <span class="title">创建人：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                <span class="obj">{{details.creatorName}}</span>
              </p>
              <p class="content">
                <span class="title">创建时间：&nbsp;&nbsp;&nbsp;</span>
                <span class="obj">{{details.createTime}}</span>
              </p>
              <p class="content">
                <span class="title">发布时间：&nbsp;&nbsp;&nbsp;</span>
                <span class="obj">{{details.publishTime}}</span>
              </p>
            </div>
            <div class="body" v-if="category == 2">
              <p class="content">
                <span class="title">发布地点：&nbsp;&nbsp;&nbsp;</span>
                <span class="obj">{{details.locationName}}</span>
              </p>
              <p class="content">
                <span class="title">信息类别：&nbsp;&nbsp;&nbsp;</span>
                <span class="obj">{{details.messageTypeName}}</span>
              </p>
              <p class="content">
                <span class="title">信息状态：&nbsp;&nbsp;&nbsp;</span>
                <span class="obj" v-if="details.statue == 1">草稿</span>
                <span class="obj" v-if="details.statue == 10">审核中</span>
                <span class="obj" v-if="details.statue == 20">审核通过</span>
                <span class="obj" v-if="details.statue == 30">审核驳回</span>
                <span class="obj" v-if="details.statue == 40">发布</span>
                <span class="obj" v-if="details.statue == 50">下线</span>
              </p>
              <p class="content" v-if="details.statue == 30">
                <span class="title">驳回原因：&nbsp;&nbsp;&nbsp;</span>
                <span class="obj">{{getRejectReasonL || details.rejectReason }}</span>
                <!-- <span class="obj">{{rejectResonText}}</span> -->
              </p>
              <p class="content">
                <span class="title">审核人：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                <span class="obj">{{details.auditorName}}</span>
              </p>
              <p class="content">
                <span class="title">创建人：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                <span class="obj">{{details.creatorName}}</span>
              </p>
              <p class="content">
                <span class="title">创建时间：&nbsp;&nbsp;&nbsp;</span>
                <span class="obj">{{details.createTime}}</span>
              </p>
              <p class="content">
                <span class="title">发布时间：&nbsp;&nbsp;&nbsp;</span>
                <span class="obj">{{details.publishTime}}</span>
              </p>
            </div>
            <div class="body" v-if="category == 3 || category == 4">
              <p class="content">
                <span class="title">信息状态：&nbsp;&nbsp;&nbsp;</span>
                <span class="obj" v-if="details.statue == 1">草稿</span>
                <span class="obj" v-if="details.statue == 10">审核中</span>
                <span class="obj" v-if="details.statue == 20">审核通过</span>
                <span class="obj" v-if="details.statue == 30">审核驳回</span>
                <span class="obj" v-if="details.statue == 40">发布</span>
                <span class="obj" v-if="details.statue == 50">下线</span>
              </p>
              <p class="content" v-if="details.statue == 30">
                <span class="title">驳回原因：&nbsp;&nbsp;&nbsp;</span>
                <span class="obj">{{details.rejectReason}}</span>
              </p>
              <p class="content">
                <span class="title">审核人：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                <span class="obj">{{details.auditorName}}</span>
              </p>
              <p class="content">
                <span class="title">创建人：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                <span class="obj">{{details.creatorName}}</span>
              </p>
              <p class="content">
                <span class="title">创建时间：&nbsp;&nbsp;&nbsp;</span>
                <span class="obj">{{details.createTime}}</span>
              </p>
              <p class="content">
                <span class="title">发布时间：&nbsp;&nbsp;&nbsp;</span>
                <span class="obj">{{details.publishTime}}</span>
              </p>
            </div>
            <div class="body" v-if="category == 5">
              <p class="content">
                <span class="title">信息标题：&nbsp;&nbsp;&nbsp;</span>
                <span class="obj">{{details.projectTitle}}</span>
              </p>
              <p class="content">
                <span class="title">运营位状态：</span>
                <span class="obj" v-if="details.operatingStatus == 0">审核中</span>
                <span class="obj" v-if="details.operatingStatus == 1">发布</span>
                <span class="obj" v-if="details.operatingStatus == 2">审核驳回</span>
                <span class="obj" v-if="details.operatingStatus == 3">下线</span>
              </p>
              <p class="content" v-if="details.operatingStatus == 2">
                <span class="title">驳回原因：&nbsp;&nbsp;&nbsp;</span>
                <span class="obj">{{details.rejectDesc}}</span>
              </p>
              <p class="content">
                <span class="title">审核人：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                <span class="obj">{{details.verifyName}}</span>
              </p>
              <p class="content">
                <span class="title">创建人：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                <span class="obj">{{details.creatorName}}</span>
              </p>
              <p class="content">
                <span class="title">创建时间：&nbsp;&nbsp;&nbsp;</span>
                <span class="obj">{{details.createTime}}</span>
              </p>
              <p class="content">
                <span class="title">发布时间：&nbsp;&nbsp;&nbsp;</span>
                <span class="obj">{{details.issuanceTime}}</span>
              </p>
            </div>
          </div>
        </div>
      </van-tab>
      <van-tab title="发布内容">
        <div class="project_list" v-if="category == 5">
          <div class="operate_message">
            <img :src="details.operatingUrl" alt="">
            <p v-if="details.projectTitle">
              <span>跳转链接来源：</span><span v-if="details.projectType == 1">招商项目</span><span v-else>营商环境</span>
            </p>
            <p v-else>
              <span>跳转链接来源：</span>
            </p>
            <p>
              <span>跳转链接信息标题：</span><span>{{details.projectTitle}}</span>
            </p>
          </div>
        </div>
        <div v-else class="project_list">
          <div class="list_message">
            <div  v-html="details.content">
              <!-- <div class="top">
                <img src="../../../assets/investment/attract.png" alt="" />
              </div>
              <div class="text">
                文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案
              </div> -->
            </div>
            <div>
              <div
                v-for="(item, index) in details.download"
                :key="index"
                @click="download(item)"
                class="download"
              >
                <img src="../../../assets/investment/download.png" alt="" />
                <div class="span">
                  <span>附件{{ index + 1 }}：{{ item.filename }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-tab>
    </van-tabs>
    <div class="foot" v-if="isSupervision !== 'supervision'">
        <button class="delete" v-if="(category != 2 && category != 5) && (details.operatingStatus == 2 || details.operatingStatus == 3 || details.statue == 30 || details.statue == 50)" @click="clean()">删除</button>
        <button class="delete" v-if="(category != 4 && category != 3) && (details.operatingStatus == 3 || details.statue == 50)" @click="update(true)">启用</button>
        <button class="delete" v-if="(category != 4 && category != 3) && (details.operatingStatus == 1 || details.statue == 40)" @click="update(false)">停用</button>
        

        <button class="reject" v-if="(getUserType == 1 || getUserType == 2) && (details.operatingStatus == 0 || details.statue == 10)"  @click="$router.push({path: '/investment/rejectReason',query:{id:id, category:category, infoId:infoId}})">审核驳回</button>
        <button class="succes" v-if="(getUserType == 1 || getUserType == 2) && (details.operatingStatus == 0 || details.statue == 10)" @click="examine()">审核通过</button>
    </div>

    <downIos :downUrl="downUrl" v-if="showDown" @cancelDown="cancelDown"></downIos>

  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Vue from "vue";
import { Tab, Tabs, DropdownMenu, DropdownItem, Notify } from "vant";
import common from '../../../utils/common.js';
import downIos from '../components/downIos'

Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Tab);
Vue.use(Tabs);
export default {
  name: "infoDetails",
  components: { downIos },
  props: {},
  data() {
    return {
      downUrl: '',
      showDown: false,
      details: {
        download:[]
      },
      information_request: {
          current: 0,
          size: 10,
          type: '',
          location: '',
          statue: '',
          status: ''
      },
      rejectResonText: ''
    };
  },
  computed: {
    ...mapGetters('investment', ['getUserType','getRejectReasonL']),
    id() {
      return this.$route.query.id;
    },
    category() {
      return this.$route.query.category;
    },
    infoId() {
      if(this.category == 1){
        return this.$route.query.infoId;
      }else{
        return null
      }
    },
    isSupervision() {
      return localStorage.getItem('attractRole')
    }
  },
  watch: {},
  methods: {
    ...mapActions("investment", [
      "setInvestmentTitle",
      "getAttractList",
      "getAttractDetails",
      "getBusinessDetails",
      "getContactUsDetails",
      "getCompanyPartnerDetails",
      "getOperatingDetail",
      "deleteAttract",
      "deleteContactUs",
      "deleteCompanyPartner",
      "updateAttract",
      "updateEnable",
      "updateDisable",
      "verifyAttract",
      "verifyContact",
      "verifyCompanyPartner",
      "verifyAgree",
      "verifyBusiness",
      "updateBusinessUsing"
    ]),
    getReturnList(id) {
      this.getAttractList(this.information_request).then(res=>{
        console.log(res);
        res.records.map((item) => {
          if (item.infoId == id) {
            this.rejectResonText = item.rejectReason
          }
        })
      }).catch(res=>{
        console.log(res);
      })
    },
     cancelDown(type){
                if(type=='success'){
                  this.showDown=false;
                  setTimeout(()=>{this.$Toast('复制成功')},1000)
                }else{
                  this.showDown=false;
                }
            },
    download(item) {
      this.downUrl = item.link
      var u = navigator.userAgent;
      const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      if (isAndroid) {
        window.location.href = item.link;
      } else {
        this.$dispatch("downIosUrl", item.link);
        this.showDown = true
      }
    },
    splitlist(res){
      res.download = [];
      if (res.filePath) {
        if (res.filePath.indexOf('◎') !== -1) {
            res.filePath = res.filePath.split("◎");
          } else if (res.filePath.indexOf(',') !== -1) {
            res.filePath = res.filePath.split(",")
          } else {
            res.filePath = [res.filePath]
          }
        res.filePath.forEach((element) => {
          res.download.push({
            link: element,
            filename: element.substring(element.lastIndexOf("&&") + 2),
          });
        });
      } else {
        res.filePath = [];
      }
      return res
    },

    clean() {//删除
      if(this.category == 1){
        this.deleteAttract({
          id: this.id,
          infoId: this.infoId
        }).then(res=>{
          Notify({ type: 'success', message: '操作成功' });
          this.$router.go(-1)
        })
      }else if(this.category == 2){
      }else if(this.category == 3){
        this.deleteContactUs({id: this.id}).then(res=>{
          Notify({ type: 'success', message: '操作成功' });
          this.$router.go(-1)
        })
      }else if(this.category == 4){
        this.deleteCompanyPartner({id: this.id}).then(res=>{
          Notify({ type: 'success', message: '操作成功' });
          this.$router.go(-1)
        })

      }else if(this.category == 5){


      }
    },

    examine(value) {//审核
      if(this.category == 1){
        this.verifyAttract({
          id: this.infoId,
          flag: 1,
        }).then(res=>{
          Notify({ type: 'success', message: '操作成功' });
          this.onRefresh()
        })
      }else if(this.category == 2){
        this.verifyBusiness({
          id: this.id,
          flag: 1,
        }).then(res=>{
          Notify({ type: 'success', message: '操作成功' });
          this.onRefresh()
        })
      }else if(this.category == 3){
        this.verifyContact({
          id: this.id,
          statue: 1,
        }).then(res=>{
          Notify({ type: 'success', message: '操作成功' });
          this.onRefresh()
        })
      }else if(this.category == 4){
        this.verifyCompanyPartner({
          id: this.id,
          statue: 1,
        }).then(res=>{
          Notify({ type: 'success', message: '操作成功' });
          this.onRefresh()
        })
      }else if(this.category == 5){
        this.verifyAgree({
          id: this.id
        }).then(res=>{
          Notify({ type: 'success', message: '操作成功' });
          this.onRefresh()
        })
      }
    },

    update(value){//停用或启用
        // if (this.details.operatingStatus == 3) {
        //   if (this.details.statue == 40) {
        //     return this.$Toast({
        //       message: "当前信息为发布状态不允许启用"
        //     });
        //   }
        // }
      if(this.category == 1){
        this.updateAttract({
          id: this.infoId,
          flag: value ? "0":"1"
        }).then(res=>{
          if (res.code !== 500) {
            Notify({ type: 'success', message: '操作成功' });
          } else {
            Notify({ type: 'danger', message: res.msg });
          }
          this.onRefresh()
        })
      }else if(this.category == 2){
        this.updateBusinessUsing({
          id: this.id,
          flag: value ? "0":"1"
        }).then(res=>{
          if (res.code !== 500) {
            Notify({ type: 'success', message: '操作成功' });
          } else {
            Notify({ type: 'danger', message: res.msg });
          }
          this.onRefresh()
        })
      }else if(this.category == 3){

      }else if(this.category == 4){

      }else if(this.category == 5){
        if(value){
          this.updateEnable({
            id: this.id
          }).then(res=>{
	          if (res.code !== 500) {
		          Notify({ type: 'success', message: '操作成功' });
	          } else {
		          Notify({ type: 'danger', message: res.msg });
	          }
	          this.onRefresh()
          })
        }else{
          this.updateDisable({
            id: this.id
          }).then(res=>{
	          if (res.code !== 500) {
		          Notify({ type: 'success', message: '操作成功' });
	          } else {
		          Notify({ type: 'danger', message: res.msg });
	          }
	          this.onRefresh()
          })
        }

      }
      return false
    },

    onRefresh(){ //初始化
      if(this.category == 1){
        this.getAttractDetails({id:this.infoId}).then(res=>{
          res = this.splitlist(res)
          this.details = res
        })
        this.getReturnList(this.infoId);
      }else if(this.category == 2){
        this.getBusinessDetails({id:this.id}).then(res=>{
          res = this.splitlist(res)
          this.details = res
        })
      }else if(this.category == 3){
        this.getContactUsDetails({id:this.id}).then(res=>{
          this.details = res.baseData
          this.details.content = res.content
        })
      }else if(this.category == 4){
        this.getCompanyPartnerDetails({id:this.id}).then(res=>{
          this.details = res.baseData
          this.details.content = res.content
        })
      }else if(this.category == 5){
        this.getOperatingDetail({id:this.id}).then(res=>{
          this.details = res
        })
      }
    }
  },
  created() {
    this.setInvestmentTitle("信息详情");
    this.onRefresh()
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
.investor_particulars {

  font-family: PingFangSC-Regular;
  padding-bottom: 108px;
  background: #F5F6F9;

  /deep/.van-tabs__line {
    background-color: #36b374;
  }
  /deep/.van-tabs__nav--line {
    .van-tab {
      flex: none;
      padding-left: 12px;
      padding-right: 12px;
    }
  }
  .information {
    background: #ffffff;
    padding: 0 20px 12px;
    margin-bottom: 12px;
    border-radius: 3px;

    .content {
      color: #333333;
      font-size: 12px;
      line-height: 17px;
      div {
        padding-top: 12px;
        display: flex;
        justify-content: flex-start;
        .name {
          white-space: nowrap;
          margin-right: 8px;
        }
      }
    }
  }
  .foot {
    position: fixed;
    bottom: 0;
    left: 0;
    bottom: 0;
    padding: 13px 0 47px;
    background: #ffffff;
    width: 100%;
    display: flex;
    justify-content: space-between;
    button {
      display: block;
      padding: 13px;
      line-height: 22px;
      font-size: 16px;
      border-radius: 3px;
      margin-left: 12px;
      margin-right: 12px;
    }
    .delete {
      width: 100%;
      background: #36b374;
      color: #ffffff;
      border: 0;
    }
    .reject {
      width: 47%;
      background: #fff;
      border: 1px solid #36b374;
      color: #36b374;
    }
    .succes {
      width: 47%;
      background: #36b374;
      border: 0;
      color: #ffffff;
    }
  }
  .record {
    /deep/.van-dropdown-menu__bar {
      background-color: transparent;
      box-shadow: none;
    }
    /deep/.van-dropdown-menu__item {
      flex: none;
    }
    /deep/.van-dropdown-menu__title {
      padding-left: 12px;
    }
    .record_list {
      padding: 0 12px 1px;
    }
  }
  .project_list {
    padding: 12px 12px 1px;
    .list_message {
      background: #ffffff;
      padding: 12px 20px;
      border-radius: 3px;
      margin-bottom: 12px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
      word-break:break-all;

      .top {
        display: flex;
        justify-content: flex-start;
        padding-bottom: 12px;
        border-bottom: 0.5px solid #EEEEEE;
        .name {
          font-size: 16px;
          color: #333333;
          line-height: 22px;
          font-weight: bold;
        }
        img {
          height: 143px;
        }
      }
      .text {
        font-size: 12px;
        line-height: 18px;
        color: #333;
        padding: 14px 0 22px 0;
        border-bottom: 1px solid #eeeeee;
      }
      .download {
        font-size: 0;
        padding: 12px 0 3px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        img {
          display: inline;
          width: 10px;
          height: 12px;
          line-height: 16px;
          margin-right: 6px;
        }
        .span {
          span {
            color: #2283e6;
            font-size: 12px;
            line-height: 16px;
            display: inline-block;
            transform: scale(0.8333);
            transform-origin: left center;
          }
        }
      }
      .body {
        padding-top: 12px;

        .content {
          margin-bottom: 12px;
          line-height: 17px;
          color: #333333;
        }
      }
      .foot {
        position: fixed;
        bottom: 0;
        left: 0;
        bottom: 0;
        padding: 13px 12px 47px;
        background: #ffffff;
        width: 100%;
        button {
          border: 0;
          background: #36b374;
          display: block;
          width: 100%;
          padding: 13px;
          line-height: 22px;
          font-size: 16px;
          color: #ffffff;
          border-radius: 3px;
        }
      }
    }
    .operate_message{
      background: #ffffff;
      padding: 12px 20px;
      border-radius: 3px;
      margin-bottom: 12px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
      word-break:break-all;
      img{
        margin-bottom: 12px;
        width: 100%;
      }
      p{
        margin-bottom: 12px;
        line-height: 17px;
        color: #333333;
      }
    }
  }
}
</style>
